import React from 'react';
import {
  Box,
  Container,
  Flex,
  Grid,
  Heading,
  Image,
  Link,
  List,
  ListItem,
  Text,
} from '@chakra-ui/react';
import { MdArrowForward } from 'react-icons/md';

const GreenReports = () => (
  <Box w="full" bgColor="#EEFFF3">
    <Container maxW="container.lg">
      <Box padding={{ xs: '50px 0px', md: '60px 50px 56px' }} mt="10px">
        <Text
          fontWeight="700"
          fontSize={{ xs: '26px', md: '36px' }}
          lineHeight="130%"
          color="#197542"
          textAlign="left"
          mb="2.5rem"
          borderLeft="3px solid #197542"
          pl="10px"
        >
          Reports
        </Text>
        <Grid templateColumns="repeat(auto-fit, minmax(300px, 1fr))" gap={6}>
          <Box
            maxW="md"
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            bg="white"
            boxShadow="md"
          >
            <Image
              src="https://static.levocdn.com/WGLBUT82/Screenshot2025-01-10at54023PM-HXVDtJONQ1aw.png" // Replace with the actual image URL
              alt="Energy transition"
              objectFit="cover"
              w="100%"
              h="200px"
            />

            <Box p={4}>
              <Heading as="h3" size="md" mb={2}>
                IVCA GreenReturns Summit 2024
              </Heading>
              <Text fontSize="sm" color="gray.600" mb={4}>
                The inaugural IVCA GreenReturns Summit 2024 was a landmark event
                that established Indiaʼs position as a pivotal player in the
                global effort to advance climate investing. Designed to attract
                international finance decision-makers and foster ....
              </Text>
              <Flex align="center">
                <Link
                  target="_blank"
                  href="https://space.levo.in.net/WGLBUT82/CopyofIVCAGreenReturnsSummit2024-10thJanpptx-JtagEtmRwcfq.pdf"
                  color="#197542"
                  fontWeight="semibold"
                  display="flex"
                  alignItems="center"
                >
                  Read More <MdArrowForward style={{ marginLeft: '8px' }} />
                </Link>
              </Flex>
            </Box>
          </Box>
          {/* 2 */}
          <Box
            maxW="md"
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            bg="white"
            boxShadow="md"
          >
            <Image
              src="https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at41343PM-6HguxP0SSZT7.png" // Replace with the actual image URL
              alt="Energy transition"
              objectFit="cover"
              w="100%"
              h="170px"
            />

            <Box p={4}>
              <Heading as="h3" size="md" mb={2}>
                Family Office Report
              </Heading>
              <Text fontSize="sm" color="gray.600" mb={4}>
                The cover of the family office report presents a vivid portrayal
                of transformation, symbolised through the journey of a simple,
                humble cotton bud evolving into a powerful rupee note. In India,
                banknotes are predominantly crafted from cotton fibre due to its
                ....
              </Text>
              <Flex align="center">
                <Link
                  target="_blank"
                  href="https://static.levocdn.com/WGLBUT82/FamilyOfficeReportSundaramAlternatescompressed1-SvIAsFPuuW0V.pdf"
                  color="#197542"
                  fontWeight="semibold"
                  display="flex"
                  alignItems="center"
                >
                  Read More <MdArrowForward style={{ marginLeft: '8px' }} />
                </Link>
              </Flex>
            </Box>
          </Box>
          <Box
            maxW="md"
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            bg="white"
            boxShadow="md"
          >
            <Image
              src="https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at41413PM-R6eoN5r11OeP.png"
              alt="Energy transition"
              objectFit="cover"
              w="100%"
              h="170px"
            />

            <Box p={4}>
              <Heading as="h3" size="md" mb={2}>
                Energy transition: India’s journey to net zero
              </Heading>
              <Text fontSize="sm" color="gray.600" mb={4}>
                India’s journey towards a sustainable future is encapsulated in
                its ambitious goal of achieving net zero emissions by 2070. This
                whitepaper sets the stage for an in-depth exploration of India’s
                .....
              </Text>
              <Flex align="center">
                <Link
                  target="_blank"
                  href="https://static.levocdn.com/WGLBUT82/EnergytransitionIndiasjourneytonetzeroPrintcompressed-lDi1GcV8eT8M.pdf"
                  color="#197542"
                  fontWeight="semibold"
                  display="flex"
                  alignItems="center"
                >
                  Read More <MdArrowForward style={{ marginLeft: '8px' }} />
                </Link>
              </Flex>
            </Box>
          </Box>
        </Grid>
      </Box>
    </Container>
  </Box>
);

export default GreenReports;
